/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReactionEventsDto } from '../../models/reaction-events-dto';
import { ReactionsClassificationResponse } from '../../models/reactions-classification-response';

export interface ClassifyReactionEvents$Params {
      body: ReactionEventsDto
}

export function classifyReactionEvents(http: HttpClient, rootUrl: string, params: ClassifyReactionEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<ReactionsClassificationResponse>> {
  const rb = new RequestBuilder(rootUrl, classifyReactionEvents.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReactionsClassificationResponse>;
    })
  );
}

classifyReactionEvents.PATH = '/api/notifications/reactions/classify';
